import Store from "App/Store.js";

export default auth => Store.dispatch({type: "auth", auth});
